export function ReturnSourceFillColor(source) {
  switch (source) {

    default:
      return "#8bc542"
  }
}
